import MessageManagerProvider from '@components/messages'
import ThemeProvider from '@components/Theme'
import { ApolloProvider } from '@dolpheen/apollo/ApolloProvider'
import AppStateProvider from '@dolpheen/containers/AppState'
import AuthProvider from '@sections/auth/AuthProvider'
import { LocaleProvider } from '@ui/Locale'
import { WindowTitleProvider } from '@ui/WindowTitle/context'
import type React from 'react'

import AppRoutes from './sections/AppRoutes'

const App: React.FC = () => (
  <LocaleProvider>
    <ApolloProvider>
      <ThemeProvider>
        <MessageManagerProvider>
          <AppStateProvider>
            <AuthProvider>
              <WindowTitleProvider>
                <AppRoutes />
              </WindowTitleProvider>
            </AuthProvider>
          </AppStateProvider>
        </MessageManagerProvider>
      </ThemeProvider>
    </ApolloProvider>
  </LocaleProvider>
)

export default App
